/* eslint-disable no-unused-vars */
import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Search from './Search';
import { isEmptyData, sendAnalyticsEvent, sendAnalyticsPageView } from '../../utils/helper';
import { getRecentList, getSavedList } from '../../store/reducers/location';
import useGoogleMapsLoader from '../../hook/useGoogleMapsLoader';

const Delivery = (props) => {
	const { isLoaded: isLoadedGoogleMaps } = useGoogleMapsLoader();
	const dispatch = useDispatch();
	const user = useSelector((store) => store?.user);

	useEffect(() => {
		sendAnalyticsPageView('search_address_session');
		sendAnalyticsEvent('Select Location', 'homepage_address', user?.address);
	}, []);

	useEffect(() => {
		if (isEmptyData(user?.token)) return;
		dispatch(getRecentList());
		dispatch(getSavedList());
	}, [user?.token]);

	if (!isLoadedGoogleMaps) return null;

	return (
		<div className='w-full h-full overflow-y-auto'>
			<div className='p-4'>
				<div className='text-base font-semibold text-gray-800 mb-4'>Pilih Lokasi</div>
				<Search {...props} />
			</div>
		</div>
	);
};

export default Delivery;
